import profileBackground from '@/../img/profile-background.jpg';
import * as dashboardSelectors from '@/dashboard/dashboard-selectors';
import { BouncingBoxWithText } from '@/widgets/bouncing-box-loader';
import { connect } from 'react-redux';
import styled from 'styled-components';

const LogoWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 700px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url(${profileBackground});
  background-size: cover;
  background-repeat: repeat;
`;

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
`;

/**
 * Loader screen with bouncing box and light blue background. Accepts loadingText prop
 * @param {string} props.loadingText
 */
export function LoadingPlaceholder(props) {
  return (
    <LogoWrapper aria-label="Preparing workspace">
      <LoaderWrapper>
        <BouncingBoxWithText loadingText={props.loadingText} />
      </LoaderWrapper>
    </LogoWrapper>
  );
}

/**
 * Bouncing box Loading placeholder. Gets its text from the redux store
 * @param {*} props
 */
function DataLoadingPlaceholderComponent(props) {
  return <LoadingPlaceholder {...props} />;
}

function mapStateToProps(state) {
  return {
    loadingText: dashboardSelectors.loadingText(state),
  };
}

export const DataLoadingPlaceholder = connect(mapStateToProps)(
  DataLoadingPlaceholderComponent
);
